import i18n from 'i18next';

import type {
  TTree,
  TFacesColumns,
  TEventsColumns,
  TObjectType,
} from '../types';

export const columnsArrayToCheckboxTree = (
  colArr: TFacesColumns[] | TEventsColumns[],
  type: TObjectType,
): TTree => {
  const tree: TTree = [{
    label: i18n.t('features:exportTask.form.tree.all'),
    value: 'all',
    children: [],
  }];

  const eventData = ['event_id', 'create_time', 'end_time', 'source', 'handler_id', 'tags', 'meta'];
  const faceData = ['face_id', 'face_detections', 'external_id', 'attach_result', 'user_data', 'age', 'gender', 'emotion', 'liveness', 'mask'];
  const bodyData = ['body_detections', 'track_id', 'upper_body', 'body_basic_attributes', 'accessories', 'lower_body'];
  const matchData = ['match_result', 'top_match'];
  const geoposition = ['district', 'area', 'city', 'street', 'house_number', 'geo_position'];

  if (type === 'faces') {
    colArr.forEach((key) => {
      tree[0]?.children?.push({
        label: i18n.t(`features:exportTask.form.checkboxGroup.faces.${key}`),
        value: key,
      });
    });
  } else if (type === 'events') {
    tree[0]?.children?.push(
      {
        label: i18n.t('features:exportTask.form.tree.eventData') as unknown as string,
        value: 'event_data',
        children: eventData.map((value) => ({
          label: i18n.t(`features:exportTask.form.checkboxGroup.${type}.${value}`),
          value,
        })),
      },
      {
        label: i18n.t('features:exportTask.form.tree.faceData'),
        value: 'face_data',
        children: faceData.map((value) => ({
          label: i18n.t(`features:exportTask.form.checkboxGroup.${type}.${value}`),
          value,
        })),
      },
      {
        label: i18n.t('features:exportTask.form.tree.bodyData'),
        value: 'body_data',
        children: bodyData.map((value) => ({
          label: i18n.t(`features:exportTask.form.checkboxGroup.${type}.${value}`),
          value,
        })),
      },
      {
        label: i18n.t('features:exportTask.form.tree.matchData'),
        value: 'match_data',
        children: matchData.map((value) => ({
          label: i18n.t(`features:exportTask.form.checkboxGroup.${type}.${value}`),
          value,
        })),
      },
      {
        label: i18n.t('features:exportTask.form.tree.geoposition'),
        value: 'geoposition',
        children: geoposition.map((value) => ({
          label: i18n.t(`features:exportTask.form.checkboxGroup.${type}.${value}`),
          value,
        })),
      },
    );
  }

  return tree;
};
